import * as React from 'react';
import PropTypes from 'prop-types';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';

SimpleMenu.propTypes = {
    items: PropTypes.array.isRequired,
};

function SimpleMenu(props) {
    const {
        items,
        anchorEl,
        setAnchorEl,
    } = props;

    const handleClose = (action) => {
        setAnchorEl(null);
        if (action) action();
    };

    return (
        <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => handleClose(null)}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 220,
                        mt: 1.5,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                        borderRadius: 2,
                    },
                },
            }}
            transformOrigin={{ horizontal: 'left', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            role="menu"
            aria-label="Menú de opciones"
        >
            {items.flatMap((item, i) => {
                const key = item.label ?? i;
                const menuItem = (
                    <MenuItem
                        key={key}
                        onClick={() => handleClose(item.action)}
                        sx={{
                            py: 1.5,
                            px: 2,
                            gap: 1.5,
                            ...(item.itemColor ? { color: item.itemColor } : {}),
                            '&:hover': {
                                backgroundColor: item.itemColor
                                    ? `${item.itemColor}12`
                                    : 'action.hover',
                            },
                        }}
                        role="menuitem"
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 40,
                                color: 'inherit',
                                '& .MuiSvgIcon-root': { fontSize: 22 },
                            }}
                        >
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText
                            primary={item.label}
                            secondary={item.secondary ?? null}
                            slotProps={{
                                primary: {
                                    variant: 'body2',
                                    fontWeight: 500,
                                },

                                secondary: {
                                    variant: 'caption',
                                    color: 'text.secondary',
                                    sx: { mt: 0.25 },
                                }
                            }} />
                    </MenuItem>
                );
                if (item.dividerBefore) {
                    return [
                        <Divider key={`${key}-divider`} sx={{ my: 1 }} />,
                        menuItem,
                    ];
                }
                return [menuItem];
            })}
        </Menu>
    );
}

export default SimpleMenu;
